import { AxiosProgressEvent } from 'axios';

export const getUploadProgress = (value: AxiosProgressEvent) => {
  if (!value.total) {
    return 0;
  }
  return Math.round((value.loaded * 100) / value.total);
};
